import { createFileRoute } from "@tanstack/react-router";
import { ArticleCardGrid } from "@/components/article-layout";
import { tutorialSections, allTutorials } from "@/lib/tutorials-data";
import { seo } from "@/lib/seo";
import { breadcrumb, collectionPage } from "@/lib/structured-data";
import { SITE_URL } from "@/lib/seo-constants";

export const Route = createFileRoute("/tutorials/")({
  head: () =>
    seo({
      title: "Tutorials: AI Marketing & GEO How-To Guides",
      description:
        "Step-by-step tutorials for setting up Axy.digital, configuring channels, and shipping autonomous campaigns.",
      path: "/tutorials",
      type: "website",
      jsonLd: [
        collectionPage({
          name: "Tutorials — Axy.digital",
          description:
            "Step-by-step tutorials for setting up Axy.digital, configuring channels, and shipping autonomous campaigns.",
          url: `${SITE_URL}/tutorials`,
          items: allTutorials.map((t) => ({
            name: t.title,
            url: `/tutorials/${t.slug}`,
          })),
        }),
        breadcrumb([
          { name: "Home", url: "/" },
          { name: "Tutorials", url: "/tutorials" },
        ]),
      ],
    }),
  component: TutorialsIndex,
});

function TutorialsIndex() {
  return (
    <div>
      <p className="text-[11px] font-medium uppercase tracking-[0.22em] text-muted-foreground mb-3">
        Documentation
      </p>
      <h1 className="text-4xl md:text-5xl font-semibold tracking-tight mb-4">
        Learn the Axy.digital engine
      </h1>
      <p className="text-lg text-muted-foreground max-w-2xl mb-12 text-pretty">
        Practical, step-by-step guides for setting up your engine, populating your knowledge base,
        and turning market signals into channel-ready campaigns.
      </p>

      <div className="space-y-12">
        {tutorialSections.map((section) => (
          <section key={section.title}>
            <h2 className="text-sm font-semibold tracking-wide uppercase text-foreground mb-4">
              {section.title}
            </h2>
            <ArticleCardGrid articleRoute="/tutorials/$slug" items={section.articles} />
          </section>
        ))}
      </div>
    </div>
  );
}
